import { render, staticRenderFns } from "./InstructionPopup.vue?vue&type=template&id=de8264ca&scoped=true&"
import script from "./InstructionPopup.vue?vue&type=script&lang=js&"
export * from "./InstructionPopup.vue?vue&type=script&lang=js&"
import style0 from "./InstructionPopup.vue?vue&type=style&index=0&id=de8264ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8264ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
